import { createReducer, on } from '@ngrx/store';
/* eslint import/no-cycle: [2, { ignoreExternal: true }] */
import { setSteps, setCurrentStep, setCompleteStep } from './wizard.actions';
import { QuoteRoutes } from '../quote.routes';

const routes = QuoteRoutes.ROUTES;

export interface Step {
  path?: string;
  fullPath?: string;
  index?: number;
  isComplete?: boolean;
  img?: string;
}

export interface State {
  steps: Step[];
  currentStep: Step;
}

export const initialState: State = {
  steps: JSON.parse(localStorage.getItem('steps')) || Object.values(routes.Steps),
  currentStep: {},
};

export const wizardReducer = createReducer(
  initialState,

  on(setSteps, (state, { steps }) => ({ ...state, steps })),
  on(setCurrentStep, (state, { currentStep }) => ({ ...state, currentStep })),
  on(setCompleteStep, ({ steps, currentStep }, { index }) => {
    const newSteps = steps.map((step, i) => {
      if (index === i) {
        return {
          ...step,
          isComplete: true,
        };
      }
      return step;
    });

    return { steps: newSteps, currentStep };
  })
);
